import { createSelector } from 'reselect';

export const getNavigation = state => state.navigation;

export const getCurrentSegmentIndex = createSelector(
  getNavigation,
  navigation => navigation.segment
);

export const getCurrentPageIndex = createSelector(
  getNavigation,
  navigation => navigation.page
);
